import React from 'react';
import { Container, Image, Row, Col } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'components/sanitizeHtml';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const WhatIsJobstas: React.FC = () => {
	const { translate } = useTranslate();
	return (
		<section className="what-is-jobstas bg-white py-80">
			<Container>
				<Row>
					<Col lg={6} className="my-auto">
						<div className="what-is-jobstas-content">
							<div className="main-heading">
								<h2 className="fw-bold mb-3 mb-md-4">
									{parse(sanitizeHtml(translate('Home.whatIsJobStasTitle')))}
								</h2>
							</div>
							<div>
								<p>{parse(sanitizeHtml(translate('Home.whatIsJobStasDescription1')))}</p>
								<p>{parse(sanitizeHtml(translate('Home.whatIsJobStasDescription2')))}</p>
								<p>{parse(sanitizeHtml(translate('Home.whatIsJobStasDescription3')))}</p>
								<p>{parse(sanitizeHtml(translate('Home.whatIsJobStasDescription4')))}</p>
								<p>{parse(sanitizeHtml(translate('Home.whatIsJobStasDescription5')))}</p>
							</div>
						</div>
					</Col>
					<Col lg={6} className="my-auto">
						<div className="what-is-jobstas-img ms-lg-auto">
							<Image
								src={IMAGE_PATHS.WhatIsJobstasImg}
								className="w-100"
								alt="description"
								loading="lazy"
							/>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default WhatIsJobstas;
